var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v("|\n  "),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }